"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchConfiguration = exports.SearchConfigurationProvider = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _fetching = require("@ori/fetching");
var _react = require("react");
var _DialogLoadingOverlay = require("../components/Loading/DialogLoadingOverlay");
var _constantsGenerated = require("../constants-generated");
var _useUrlOptions = require("../hooks/useUrlOptions");
var _models = require("../models");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
/** Pickup search configuration context enhanced by additional properties (mapMethods). */

const pickupPointsSearchConfigurationContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const SearchConfigurationProvider = ({
  showFullScreenLoader,
  children
}) => {
  const [mapMethods, setMapMethods] = (0, _react.useState)();
  const {
    cacheKeys,
    urlOptions
  } = (0, _useUrlOptions.useUrlOptions)('/system/ajax/DeliverySelection/GetPickupSearchConfiguration');
  const config = (0, _fetching.useSWR)(cacheKeys, async () => (0, _checkoutUtils.catchPromiseError)((0, _utils.getUrl)(urlOptions), `Error in SearchConfigurationProvider`, _constantsGenerated.PACKAGE_NAME), _checkoutUtils.errorHandlingSwrOptions);
  const [viewSettings, setViewSettings] = (0, _react.useState)();

  // Initialize view settings
  (0, _react.useEffect)(() => {
    if (!config.data || viewSettings) {
      return;
    }
    setViewSettings({
      location: config.data.mapConfiguration.fallbackStartingLocation,
      zoom: config.data.mapConfiguration.initialZoom
    });
  }, [config.data, viewSettings]);
  const value = (0, _react.useMemo)(() => config.data && viewSettings ? {
    display: config.data.display,
    filters: config.data.filters,
    formattedSearchConfiguration: config.data.formattedSearchConfiguration,
    isInstantResultShown: config.data.isInstantResultShown,
    maxDisplayedSearchResults: config.data.maxDisplayedSearchResults,
    credentials: config.data.mapConfiguration.account.credentials ?? '',
    minZoom: config.data.mapConfiguration.minZoom,
    zoomAfterSelection: config.data.mapConfiguration.zoomAfterSelection,
    mapProvider: config.data.mapConfiguration.provider,
    mapMethods,
    setMapMethods,
    viewSettings,
    setViewSettings: setViewSettings
  } : undefined, [config.data, mapMethods, viewSettings]);

  // Show loading overlay if data is not yet loaded
  if (config.isValidating || !value) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogLoadingOverlay.DialogLoadingOverlay, {
      id: _models.TestId.DialogLoadingOverlayPickupPointsDialogContent,
      isFullScreen: showFullScreenLoader
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(pickupPointsSearchConfigurationContext.Provider, {
    value: value,
    children: children
  });
};
exports.SearchConfigurationProvider = SearchConfigurationProvider;
const useSearchConfiguration = () => {
  const ctx = (0, _react.useContext)(pickupPointsSearchConfigurationContext);
  if (!ctx) {
    throw new Error('useSearchConfiguration must be used within a SearchConfigurationProvider');
  }
  return ctx;
};
exports.useSearchConfiguration = useSearchConfiguration;